export default __webpack_public_path__ + "static/media/image13tum.2d7224eb.jpg";